import * as Mapbox from '@mapbox/mapbox-gl-supported'
import { memoize } from '@avcan/utils/function'

export const supported = memoize(() => Mapbox.supported())
